import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'disabled': false,
  'update': false,
  'list': [],
};

const updateUsersList = (list, index, newUser) => {
  const newObject = {...list[index], ...newUser};
  if (index !== 'ALL') {
    return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
  }

  return list.map((user) => ({...user, ...newUser}));
};

export const externalUsers = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_EXTERNAL_USERS_LIST_BY_GROUP]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_EXTERNAL_USERS_LIST_BY_GROUP]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_EXTERNAL_USERS_LIST_BY_GROUP_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.ADDING_NEW_EXTERNAL_USER_BY_GROUP]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_NEW_EXTERNAL_USER_BY_GROUP]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.ADDED_NEW_EXTERNAL_USER_BY_GROUP_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATE_EXTERNAL_USER_LIST]: (state, action) => {
      const {index, data} = action.payload;
      const updatedList = updateUsersList(state.list, index, data);
      return {
        ...state,
        'disabled': false,
        'update': true,
        'list': updatedList,
      };
    },
    [ActionTypes.UPDATED_ALL_EXTERNAL_USER_BY_GROUP_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_ALL_EXTERNAL_USER_BY_GROUP]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_ALL_EXTERNAL_USER_BY_GROUP]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'update': false,
        'list': action.response.data,
      };
    },
    [ActionTypes.DELETING_EXTERNAL_USER_BY_GROUP]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_EXTERNAL_USER_BY_GROUP]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.DELETED_EXTERNAL_USER_BY_GROUP_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CLEAR_EXTERNAL_USERS_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};
